import { IS_WL_QUERY_TRUE_STRING } from '../../constants';

export const checkIsWLByUrl = (url?: string): boolean =>
  !!url && (url?.includes('/wl') || url?.includes(IS_WL_QUERY_TRUE_STRING));
